export interface PunchCardDetailsChartDTO {
  horasTrabalhadas?: number;
  horasSaidaAntecipada?: number;
  horasAlmoco?: number;
  horasAtrasadas?: number;
  horasExtras50?: number;
  horasExtras60?: number;
  horasExtras75?: number;
  horasExtras80?: number;
  horasExtras100?: number;
  horasExtras140?: number;
  horasExtras200?: number;
  mesReferencia?: string;
  faltas?: number;
  atrasos?: number;
  horasExtras?: number;
  horasEmAfastamento?: number;
  horasEmFerias?: number;
  horasAfastamento?: number;
  horasAtrasos?: number;
  horasFaltas?: number;
  horasFerias?: number;
}

export interface PunchCardGroupedChartDTO {
  mesReferencia?: string;
  horasTrabalhadas?: number;
  horasExtras?: number;
  horasAfastamento?: number;
  horasAtrasos?: number;
  horasFaltas?: number;
  horasFerias?: number;
}

export const mappedAttributeLabel = Object.freeze({
  faltas: 'Faltas',
  atrasos: 'Atrasos',
  horasExtras: 'Horas Extras',
  horasEmAfastamento: 'Afastamento',
  horasEmFerias: 'Férias',
  horasTrabalhadas: 'Horas Trabalhadas',
  horasSaidaAntecipada: 'Horas Saída Antecipada',
  horasAlmoco: 'Hora de Almoço',
  horasAtrasadas: 'Horas Em Atraso',
  horasExtras50: 'Horas Extras 5',
  horasExtras60: 'Horas Extras 6',
  horasExtras75: 'Horas Extras 7',
  horasExtras80: 'Horas Extras 8',
  horasExtras100: 'Horas Extras 10',
  horasExtras140: 'Horas Extras 14',
  horasExtras200: 'Horas Extras 20',
  horasAfastamento: 'Afastamento',
  horasAtrasos: 'Atrasos',
  horasFaltas: 'Faltas',
  horasFerias: 'Férias',
});

export type PunchCardDetailsChartType = Omit<
  PunchCardDetailsChartDTO,
  'mesReferencia'
>;

export const getPunchCardAttributeLabel = (
  attributeName: keyof PunchCardDetailsChartType,
) => {
  return mappedAttributeLabel[attributeName];
};
